import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Inline notice. now = honest degradation / consent / attention; info = neutral tip; success; record = live recording notice;
 * danger = an error (--status-danger-fg text on the pale alert wash; never the recording red).
 */
export interface CalloutProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: "now" | "info" | "success" | "record" | "danger";
  icon?: string;
  children: React.ReactNode;
}

export function Callout({ tone = "now", icon = "info", className, children, ...rest }: CalloutProps): JSX.Element {
  return (
    <div role="note" className={["gk-callout", "gk-callout--" + tone, className].filter(Boolean).join(" ")} {...rest}>
      <Icon name={icon} size={18} />
      <div>{children}</div>
    </div>
  );
}
